<template>
<div class="home">
    <div class="d-sm-flex align-items-center justify-content-between mb-3">
        <div>
            <ol class="breadcrumbs">
                <router-link to="/dashboard">Dashboard</router-link> >
                <span v-if="orgUrl">
                    <router-link to="/organisations">Organisations</router-link> > <router-link to="{ name: 'org-edit', params:{ id: org.url }}">{{org.name}}</router-link> > Timesheet
                </span>
            </ol>
            <div class="d-sm-flex align-items-center justify-content-between mb-0">
                <h1 v-if="orgUrl" class="h3 mb-0 text-gray-800">{{org.name}} Timesheet</h1>
            </div>
        </div>
        <div>
            <div style="display: inline-block;" class="custom-control custom-checkbox small mr-3">
                <input v-model="showStats" @change="showStatsChange($event)" type="checkbox" class="custom-control-input" id="showStats" />
                <label class="custom-control-label" for="showStats">Show Stats</label>
            </div>
            <router-link to="/create-job" class="d-none d-sm-inline-block btn btn-primary shadow-sm"><i class="fas fa-plus fa-sm text-white-50"></i> New Job</router-link>
        </div>
    </div>

    <job-table :statusStep="statusStep"></job-table>
</div>
</template>

<script>
import {
    db
} from '../main'

//import LineChart from '@/components/LineChart.js'
//import DoughnutChart from '@/components/DoughnutChart.js'
import JobTable from "@/components/JobTable";
import getOrganisation from "../mixins/getOrganisation";

export default {
    name: "Timesheet",
    mixins: [getOrganisation],
    components: {
        JobTable,
        //LineChart,
        //DoughnutChart
    },
    data() {
        return {
            showStats: false,
            statusStep: null,
            datacollection: null,
            dataOptions: null,
            donutData: null,
            donutOptions: null,
            stats: {},
            statsByDay: null,
            completedByDay: [],
            jobsByDay: [],
            inwardsByDay: [],
            dayLabels: [],
            statusHex: [],
            totalNewJobs: 0,
            totalCompleted: 0,
            statusKeysEncode: []
        };
    },
    computed: {

    },

    mounted() {
        const t = this;
        if (localStorage.getItem('showStats')) {
            t.showStats = JSON.parse(localStorage.getItem('showStats'));
        }

        db.ref('stats').on('value', snapshot => {
            t.stats = snapshot.val();
            if (t.stats && t.stats.status['Completed']) {
                delete t.stats.status['Completed'];
            }
            t.statusHex = [];
            t.statusKeysEncode = [];
            for (const [key] of Object.entries(t.stats.status)) {
                t.statusKeysEncode.push(key.replace(/_/g, '/'));
                t.statusHex.push(t.$options.filters.statusHex(key));
            }
            t.fillDonutData();
            console.log(t.statusHex);

        })
        db.ref('statsByDay').limitToLast(7).on('value', snapshot => {
            t.statsByDay = snapshot.val();
            t.completedByDay = [];
            t.jobsByDay = [];
            t.inwardsByDay = [];
            t.dayLabels = [];
            snapshot.forEach(function (child) {

                var chartDate = t.$options.filters.chartDate(child.key);

                t.totalCompleted += child.val().completed;
                t.completedByDay.push({
                    t: chartDate,
                    y: child.val().completed
                });
                t.totalNewJobs += child.val().jobs;
                t.jobsByDay.push({
                    t: chartDate,
                    y: child.val().jobs
                });
                t.inwardsByDay.push({
                    t: chartDate,
                    y: child.val().inwards
                });
                t.dayLabels.push(chartDate);
            });
            console.log(t.completedByDay);
            t.fillLineData();
        })
    },

    methods: {
        showStatsChange() {
            localStorage.setItem('showStats', JSON.stringify(this.showStats));
            if (this.showStats) {
                this.fillLineData();
                this.fillDonutData();
            }
        },
        fillLineData() {
            const t = this;
            this.dataOptions = {
                legend: {
                    display: true,
                    position: "bottom",
                },
                layout: {
                    padding: {
                        left: 0,
                        right: 0,
                        top: 30,
                        bottom: 20
                    }
                },
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true,
                            stepSize: 1
                        }
                    }],
                    xAxes: [{
                        type: 'time',
                        time: {
                            unit: 'day',
                            displayFormats: {
                                day: 'ddd, MMM D'
                            }
                        },
                        display: true,
                        scaleLabel: {
                            display: false,
                            labelString: 'Day'
                        }
                    }]
                },
                responsive: true,
                maintainAspectRatio: false
            }
            this.datacollection = {
                labels: t.dayLabels,
                datasets: [{
                    label: 'Jobs Created',
                    data: t.jobsByDay,
                    backgroundColor: [
                        'rgb(141, 198, 63, 0.1)',
                    ],
                    borderColor: [
                        'rgba(141, 198, 63, 1)',
                    ],
                    borderWidth: 2
                }, {
                    label: 'Inwards Recorded',
                    data: t.inwardsByDay,
                    backgroundColor: [
                        'rgba(54, 185, 204, 0.1)',
                    ],
                    borderColor: [
                        'rgba(54, 185, 204,1)',
                    ],
                    borderWidth: 2
                }, {
                    label: 'Jobs Completed',
                    data: t.completedByDay,
                    backgroundColor: [
                        'rgba(44, 44, 44, 0.1)',
                    ],
                    borderColor: [
                        'rgba(44, 44, 44,1)',
                    ],
                    borderWidth: 2
                }]
            }
        },
        fillDonutData() {
            const t = this;
            this.donutData = {
                labels: t.statusKeysEncode,
                datasets: [{
                    backgroundColor: t.statusHex,
                    data: Object.values(t.stats.status)
                }]
            }
            this.donutOptions = {

                legend: {
                    display: true,
                    position: "right",
                    labels: {
                        boxWidth: 14
                    },
                    title: {
                        display: true,
                        text: 'Custom Chart Title',
                        position: 'bottom'
                    },
                },
                layout: {
                    padding: {
                        left: 0,
                        right: 0,
                        top: 40,
                        bottom: 40
                    }
                },
                responsive: true,
                maintainAspectRatio: false,
                cutoutPercentage: 65
            }

        }
    },
};
</script>
